module.exports = __webpack_public_path__ + "img/oaa-logo-bw.b1e9ebd4.png";